<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="accounts"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Account Profile</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item-divider color="secondary">
        General
    </ion-item-divider>

    <ion-list>

        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Dealership</span><br />
                <span class="line2">{{dealership?.dealershipName}}</span><br />
                <!-- <span class="line2">{{getPhoneNumberFormatted()}}</span><br /> -->
                <span class="line2">{{dealership?.phoneNumber | myPhone}}</span><br />
                <span class="line2">{{dealership?.address.fullAddress}}</span>
                <!-- <span class="line2">All Managers: {{allManagers}}</span> -->
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Account Number</span><br />
                <span class="line2">{{accountProfile?.accountNumber}}</span><br />
            </ion-label>
        </ion-item>
        
        <ion-item data-test="statusItem" detail="true" (click)="onStatusClick()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Account Status</span><br />
                <span class="line2">{{accountProfile?.status}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="package">
            <ion-label class="ion-text-wrap">
                <span class="line1">Current Package</span><br />
                <span class="line2">{{accountProfile?.packageName}}</span><br />
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Sign Up Date</span><br /> 
                <span class="line2">{{accountProfile?.signupDate | 
                        myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="expirationDateItem" detail="true" (click)="onExpirationDateClick()" href="javascript:;">
            <ion-label text-class="ion-text-wrap">
                <span class="line1">Expiration Date</span><br />
                <span class="line2">{{accountProfile?.periodInfo.expirationDate | 
                        myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}
                </span>
            </ion-label>
        </ion-item>

        <ion-item data-test="premiumSupportItem" (click)="onPremiumSupportExpirationDateClick()" detail="true" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Premium Support Expiration Date</span><br />
                <span class="line2">{{accountProfile?.periodInfo.premiumSupportExpirationDate | 
                        myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}
                </span>
            </ion-label>
        </ion-item>

        <ion-item data-test="hostingExpirationItem" (click)="onHostingExpirationDateClick()" detail="true" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Web Hosting Expiration Date</span><br />
                <span class="line2">{{accountProfile?.periodInfo.webHostingExpirationDate | 
                        myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}
                </span>
            </ion-label>
        </ion-item>

    </ion-list>
<!-- 
    <ion-item>
        <ion-label class="ion-text-wrap" position="stacked">
            <strong>Notes</strong>
        </ion-label>
        <ion-textarea color="secondary" type="text" rows="6" name="notes" #notes [(ngModel)]="accountProfile.notes"></ion-textarea>
    </ion-item> -->

</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="saveButton" color="primary" expand="full" (click)="onSaveClick()">Save</ion-button>
    </ion-toolbar>
</ion-footer>
